import React from 'react';
import { handleCheckout } from '../utils/checkout';
export function OfferStack() {
  return <section id="purchase" className="bg-warm-mid py-20 md:py-28 px-4" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        {/* Section header */}
        <div className="text-center mb-10" data-id="element-171">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-warm-hero leading-tight mb-3" data-id="element-172">
            Get The <span className="italic text-soft-gold" data-id="element-173">Pawfect</span> Shot
            MegaPack Today
          </h2>
          <p className="font-sans text-lg md:text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed" data-id="element-174">
            Everything you need to start taking better dog photos with the phone
            you already own.
          </p>
        </div>

        {/* Offer card */}
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-soft-gold/25 shadow-xl" data-id="element-175">
          <h3 className="font-sans text-lg md:text-xl font-bold text-warm-hero mb-6 pb-4 border-b border-gray-200" data-id="element-176">
            Today you'll receive:
          </h3>

          <ul className="space-y-3 mb-8" data-id="element-177">
            {[{
            text: '6 Dog Photography Guides',
            bold: true
          }, {
            text: 'Bonus #1: 30 Sit-Snap-Shoot Cheat Sheets',
            bold: true
          }, {
            text: 'Bonus #2: 7 Lightroom Editing Walkthroughs',
            bold: true
          }, {
            text: 'Bonus #3: Photo Settings & Setup Guide',
            bold: true
          }, {
            text: 'Instant digital access',
            bold: false
          }, {
            text: 'One-time payment',
            bold: false
          }, {
            text: 'Lifetime access',
            bold: false
          }].map((item, index) => <li key={index} className="flex items-center" data-id="element-178">
                <span className="text-green-500 text-lg mr-3 flex-shrink-0" data-id="element-179">
                  ✅
                </span>
                <span className={`font-sans text-base md:text-lg ${item.bold ? 'font-bold text-warm-hero' : 'text-gray-600'}`} data-id="element-180">
                  {item.text}
                </span>
              </li>)}
          </ul>

          {/* Price block */}
          <div className="bg-cream rounded-xl p-6 md:p-8 text-center border border-soft-gold/15 mb-8" data-id="element-181">
            <p className="font-sans text-gray-500 text-base mb-1" data-id="element-182">
              Regular Price:{' '}
              <span className="line-through text-red-400" data-id="element-183">USD $89.00</span>
            </p>
            <p className="font-sans text-warm-hero text-lg font-bold mb-2 uppercase tracking-wide" data-id="element-184">
              Launch Special Today:
            </p>
            <p className="font-serif text-5xl md:text-6xl font-bold text-green-600" data-id="element-185">
              USD $13.99
            </p>
          </div>

          {/* Buy button */}
          <button onClick={handleCheckout} className="w-full bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-xl md:text-2xl py-5 px-8 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase mb-5" data-id="element-186">
            👉 Get My MegaPack Now
          </button>

          {/* Microcopy */}
          <p className="font-sans text-sm text-gray-400 text-center" data-id="element-187">
            Instant access • One-time payment • Digital download • Lifetime
            access
          </p>
        </div>
      </div>
    </section>;
}